/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerificationTokenDto
 */
export interface VerificationTokenDto {
    /**
     * Email verification token
     * @type {string}
     * @memberof VerificationTokenDto
     */
    token: string;
}

/**
 * Check if a given object implements the VerificationTokenDto interface.
 */
export function instanceOfVerificationTokenDto(value: object): value is VerificationTokenDto {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function VerificationTokenDtoFromJSON(json: any): VerificationTokenDto {
    return VerificationTokenDtoFromJSONTyped(json, false);
}

export function VerificationTokenDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerificationTokenDto {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function VerificationTokenDtoToJSON(value?: VerificationTokenDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'token': value['token'],
    };
}

